import { of as observableOf, Observable } from 'rxjs'

import { mergeMap } from 'rxjs/operators'
import { Component, OnInit, ViewChild } from '@angular/core'
import { EntityGroupODataService, IEntityGroup } from '@exchange/domain/.'
import { ActivatedRoute, Router } from '@angular/router'
import { EntityGroupEditGeneralComponent } from '../entity-group-edit-general/entity-group-edit-general.component'
import { TabsetComponent } from 'ngx-bootstrap/tabs'
import _ from 'lodash'
import { ToastrService } from 'ngx-toastr'
import { UtilService } from '@exchange/app/services'
import { PagedResult } from 'common-services'

@Component({
  selector: 'app-entity-group-edit',
  templateUrl: './entity-group-edit.component.html',
  styleUrls: ['./entity-group-edit.component.scss'],
  standalone: false
})
export class EntityGroupEditComponent implements OnInit {
  @ViewChild('general') general: EntityGroupEditGeneralComponent
  @ViewChild('tabs') tabs: TabsetComponent

  title = 'Edit Entity Group'
  busy: any = null

  model: IEntityGroup = {} as IEntityGroup

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private odata: EntityGroupODataService,
    private toastr: ToastrService,
    private util: UtilService
  ) {}

  initializeAdd() {
    this.title = 'Add Entity Group'
    const provider = {
      Id: 0,
      Name: ''
    } as IEntityGroup
    const paged = {
      skipped: 0,
      rowCount: 1,
      data: [provider]
    } as PagedResult<IEntityGroup>

    return observableOf(paged)
  }

  initializeEdit() {
    return this.initializeModel()
  }

  private initializeModel(): Observable<PagedResult<IEntityGroup>> {
    return this.route.params.pipe(
      mergeMap(params => {
        const id = +params['id']
        return this.odata.query().filter(`Id eq ${id}`).exec()
      })
    )
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = +params['id']
      const fn = id ? this.initializeEdit.bind(this) : this.initializeAdd.bind(this)

      fn().subscribe(response => {
        this.model = response.data[0]
      })
    })
  }

  onSubmit(): boolean {
    const selectedTab = this.tabs.tabs.find(x => x.active).heading

    if (selectedTab === 'General') {
      this.general.save().subscribe(value => {
        this.busy = null

        if (_.isArray(value)) {
          this.toastr.error(value.join('<br />'))
          return
        }

        if (this.model.Id) {
          this.backToList('Entity Group was saved successfully.')
        } else {
          this.toastr.success('Entity Group was added successfully.')

          this.model.Id = value.Id

          const newUrl = this.router.createUrlTree([`${this.model.Id}`], {
            relativeTo: this.route.parent
          })

          this.router.navigateByUrl(newUrl)

          setTimeout(() => {
            this.tabs.tabs[1].active = true
          }, 0)
        }
      })
    }

    return false
  }

  showError(response): void {
    this.busy = null

    const msg = this.util.getErrorString(response)

    this.toastr.error(msg)
  }

  backToList(successMessage: string = null) {
    this.router.navigate(['/system', 'entitygroups'], { queryParams: { successMessage } })
  }
}
